export default __webpack_public_path__ + "static/media/graph-type-1.7302fe76.png";